import { useContext } from "react";
import { UserContext } from "../userContext/userContext";
import useLogout from "../hooks/useLogout";
import '../App.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function HeaderHomeAdmin() {
  const { userState } = useContext(UserContext);
  const isLogged = userState.isLogged;
  const logout = useLogout();

  return (
    <>
      <img src="/bandeau.jpg" className="banner-img" alt="Bandeau LSR 47" />
      <div className="App">
        <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect className="site-navbar">
          <Container fluid="lg" className="site-navbar-container">
            <Navbar.Toggle aria-controls="admin-navbar" />
            <Navbar.Collapse id="admin-navbar" className="justify-content-center">
              <Nav className="site-nav">
                {!isLogged && <Nav.Link href="/login">Espace CA</Nav.Link>}
                <Nav.Link href="/admin/gestion">Gestion</Nav.Link>
                <Nav.Link href="/admin/statistique">Statistiques</Nav.Link>
                {isLogged && (
                  <Nav.Link
                    onClick={logout}
                    href="/"
                  >
                    Deconnexion
                  </Nav.Link>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
}

export default HeaderHomeAdmin;
